import { create } from 'zustand';

export const useExerciseParticipantStore = create((set) => ({
    items: [],
    loading: false,
    error: null,

    paginationData: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 10,
        hasNextPage: false,
        hasPreviousPage: false,
    },

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setPaginationData: (paginationData) => set({ paginationData }),
}));

export default useExerciseParticipantStore;
